import React from 'react';
import useFieldHelper from './fieldHelper';
import TextField from './text/TextField';
import { FieldProps } from './types';

const BooleanField = (props: FieldProps<boolean>) => {
  const { getValue } = useFieldHelper<boolean>(props);
  const displayedValue = getValue() ? 'Yes' : 'No';

  return <TextField {...props} value={displayedValue} />;
};

export default BooleanField;
